// @ts-expect-error
import { theme } from '@chakra-ui/pro-theme';
import { extendTheme } from '@chakra-ui/react';
// @ts-ignore
import Color from 'color';
import fonts from 'foundations/fonts';

import { fontWeights } from '../global/Fonts';
import tokens from './tokens';

export const brandColors = {
  blue: {
    light: Color('#3F7DC1').mix(Color('white'), 0.4).hex(),
    50: Color('#3F7DC1').mix(Color('white'), 0.95).hex(),
    100: Color('#3F7DC1').mix(Color('white'), 0.9).hex(),
    200: Color('#3F7DC1').mix(Color('white'), 0.8).hex(),
    300: Color('#3F7DC1').mix(Color('white'), 0.7).hex(),
    400: Color('#3F7DC1').mix(Color('white'), 0.6).hex(),
    500: Color('#3F7DC1').hex(),
    600: Color('#3F7DC1').mix(Color('white'), 0.4).hex(),
    700: Color('#3F7DC1').mix(Color('white'), 0.3).hex(),
    800: Color('#3F7DC1').mix(Color('white'), 0.2).hex(),
    900: Color('#3F7DC1').mix(Color('white'), 0.1).hex(),
    default: '#3F7DC1',
  },
  gray: {
    darkest: Color('#F0F0F0').mix(Color('black'), 0.6).hex(),
    darker: Color('#F0F0F0').mix(Color('black'), 0.4).hex(),
    dark: Color('#F0F0F0').mix(Color('black'), 0.1).hex(),
    dimmed: '#E0E0E0',
    default: '#F0F0F0',
  },

  red: {
    default: '#E53E3E',
  },

  orange: {
    default: '#E95C0E',
  },

  white: {
    default: '#FFFFFF',
  },
};

export const statusCodes = {
  created: {
    base: 'gray',
    light: 'gray.100',
    medium: 'gray.200',
    dark: 'gray.300',
    text: 'black',
  },

  submitted: {
    base: 'black',
    light: 'black.100',
    medium: 'black.200',
    dark: 'black.900',
    text: 'white',
  },

  completed: {
    base: 'green',
    light: 'green.100',
    medium: 'green.200',
    dark: 'green.500',
    text: 'white',
    bmw_transfer_ok: Color('green').mix(Color('white'), 0.77).hex(),
    bmw_transfer_not_ok: Color('green').mix(Color('white'), 0.84).hex(),
  },

  pending: {
    base: 'blue',
    light: 'blue.100',
    medium: 'blue.200',
    dark: 'blue.500',
    text: 'white',
  },

  on_hold: {
    base: 'purple',
    light: 'purple.100',
    medium: 'purple.200',
    dark: 'purple.500',
    text: 'white',
    on_hold_first_order: Color('purple').mix(Color('white'), 0.1).hex(),
    on_hold_technical_issue: Color('purple').mix(Color('white'), 0.3).hex(),
    on_hold_requested_deletion: Color('purple').mix(Color('white'), 0.5).hex(),
  },

  clarification: {
    base: 'orange',
    light: 'orange.100',
    medium: 'orange.200',
    dark: 'orange.500',
    text: 'white',
    invalid_vin: Color('orange').mix(Color('white'), 0.2).hex(),
    implausible_mileage: Color('orange').mix(Color('white'), 0.4).hex(),
    warning_cancellation: Color('orange').mix(Color('black'), 0.5).hex(),
    missing_document: Color('orange').mix(Color('black'), 0.3).hex(),
    registration_certificate_needed: Color('orange').mix(Color('black'), 0.1).hex(),
    bmw_existing_accounts: Color('orange').mix(Color('black'), 0.6).hex(),
    invoice_needed: Color('orange').mix(Color('black'), 0.7).hex(),
  },

  blocked: {
    base: 'orange',
    light: 'orange.100',
    medium: 'orange.200',
    dark: 'orange.500',
    text: 'white',
  },

  not_registered: {
    base: 'orange',
    light: 'orange.100',
    medium: 'orange.200',
    dark: 'orange.500',
    text: 'white',
  },

  processing: {
    base: 'black',
    light: 'black.100',
    medium: 'black.200',
    dark: 'black.500',
    text: 'white',
    transfer_hyundai: Color('black').mix(Color('white'), 0.4).hex(),
    processing_correction: Color('black').mix(Color('white'), 0.2).hex(),
  },

  registration_pending: {
    base: 'black',
    light: 'black.100',
    medium: 'black.200',
    dark: 'black.900',
    text: 'white',
  },

  rejected: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
    invalid_document: Color('red').mix(Color('white'), 0.28).hex(),
    inconsistent_data: Color('red').mix(Color('white'), 0.35).hex(),
  },

  approved: {
    base: 'green',
    light: 'green.100',
    medium: 'green.200',
    dark: 'green.500',
    text: 'white',
  },

  canceled: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
    invalid_vin: Color('red').mix(Color('white'), 0.07).hex(),
    no_clarification: Color('red').mix(Color('white'), 0.6).hex(),
    duplicate: Color('red').mix(Color('white'), 0.98).hex(),
    no_dsb: Color('red').mix(Color('white'), 0.14).hex(),
  },

  // B2C service history requests (string enum B2CServiceHistoryStatus)
  pending_payment: {
    base: 'green',
    light: 'green.100',
    medium: 'green.200',
    dark: 'green.500',
    text: 'white',
  },

  paid: {
    base: 'green',
    light: 'green.100',
    medium: 'green.200',
    dark: 'green.500',
    text: 'white',
  },

  expired: {
    base: 'black',
    light: 'black.100',
    medium: 'black.200',
    dark: 'black.900',
    text: 'white',
  },

  paid_expired: {
    base: 'black',
    light: 'black.100',
    medium: 'black.200',
    dark: 'black.900',
    text: 'white',
  },

  canceled_payment_failed: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
  },

  canceled_payment_overdue: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
  },

  canceled_invalid_vin: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
  },

  canceled_no_dsb: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
  },

  canceled_no_dsb_portal: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
  },

  canceled_rejected: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
  },

  default: {
    base: 'gray',
    light: 'gray.100',
    medium: 'gray.200',
    dark: 'gray.500',
    text: 'white',
  },

  account_setup: {
    base: 'orange',
    light: 'orange.100',
    medium: 'orange.200',
    dark: 'orange.500',
    text: 'white',
  },
  registered: {
    base: 'blue',
    light: 'blue.100',
    medium: 'blue.200',
    dark: 'blue.500',
    text: 'white',
  },
  registered_legacy: {
    base: 'blue',
    light: 'blue.100',
    medium: 'blue.200',
    dark: 'blue.500',
    text: 'white',
  },
  preregistered: {
    base: 'cyan',
    light: 'cyan.100',
    medium: 'cyan.200',
    dark: 'cyan.500',
    text: 'white',
  },
  deleted: {
    base: 'red',
    light: 'red.100',
    medium: 'red.200',
    dark: 'red.500',
    text: 'white',
  },

  requested_deletion: {
    base: 'black',
    light: 'black.100',
    medium: 'black.200',
    dark: 'black.500',
    text: 'white',
  },

  active: {
    base: 'green',
    light: 'green.100',
    medium: 'green.200',
    dark: 'green.500',
    text: 'white',
  },
  resolved: {
    base: 'green',
    light: 'green.100',
    medium: 'green.200',
    dark: 'green.500',
    text: 'white',
  },

  open: {
    base: 'black',
    light: 'black.100',
    medium: 'black.200',
    dark: 'black.900',
    text: 'white',
  },
};
export type StatusReasons = {
  canceled: {
    invalid_vin: string;
  };
  no_dsb: string;
  missing_document: string;
  registration_certificate_needed: string;
  invalid_document: string;
  inconsistent_data: string;
  transfer_hyundai: string;
  on_hold_first_order: string;
  on_hold_technical_issue: string;
  clarification: {
    invalid_vin: string;
  };
  implausible_mileage: string;
  warning_cancellation: string;
  bmw_transfer_ok: string;
  bmw_transfer_not_ok: string;
  no_clarification: string;
  duplicate: string;
};

export const myTheme: Record<string, any> = extendTheme(
  {
    semanticTokens: {
      ...tokens,
    },
    fonts: {
      ...fonts,
    },

    colors: {
      ...theme.colors,
      gray: {
        darker: Color('#F0F0F0').mix(Color('black'), 0.4).hex(),
        dark: Color('#F0F0F0').mix(Color('black'), 0.1).hex(),
        dimmed: '#E0E0E0',
        default: '#F0F0F0',
      },
      black: {
        '50': Color('#000000').mix(Color('white'), 0.95).hex(),
        '100': Color('#000000').mix(Color('white'), 0.9).hex(),
        '200': Color('#000000').mix(Color('white'), 0.8).hex(),
        '300': Color('#000000').mix(Color('white'), 0.7).hex(),
        '400': Color('#000000').mix(Color('white'), 0.6).hex(),
        '500': Color('#000000').mix(Color('white'), 0.5).hex(),
        '600': Color('#000000').mix(Color('white'), 0.4).hex(),
        '700': Color('#000000').mix(Color('white'), 0.3).hex(),
        '800': Color('#000000').mix(Color('white'), 0.2).hex(),
        '900': Color('#000000').mix(Color('white'), 0.1).hex(),
      },
      blue: {
        ...brandColors.blue,
      },
      brand: {
        blue: {
          ...theme.colors.blue,
          ...brandColors.blue,

          500: brandColors.blue.default,
          700: brandColors.blue.default,
          dark: Color(brandColors.blue.default).mix(Color('black'), 0.7).hex(),
        },

        gray: {
          ...theme.colors.gray,
          default: '#F0F0F0',
        },
      },

      status: {
        error: '#E95C0E',
        warning: '#DD6B21',
      },
      statusCodes: { ...statusCodes },
    },

    styles: {
      global: {
        '@keyframes totp-code-blink': {
          '0%, 100%': { color: 'black' },
          '50%': { color: Color('#000000').mix(Color('white'), 0.5).hex() }, // matches colors.black['500']
        },
        '@keyframes rainbow-border-spin': {
          from: { transform: 'rotate(0deg)' },
          to: { transform: 'rotate(360deg)' },
        },
      },
    },

    components: {
      Checkbox: {
        sizes: {
          xl: {
            control: {
              w: 10,
              h: 10,
            },
            label: {
              fontSize: 'lg',
            },
            icon: {
              fontSize: '1.25rem',
            },
          },
        },
        // can be Radio
        baseStyle: {
          label: {
            touchAction: 'none',
          },
        },
      },

      Heading: {
        sizes: {
          ...theme.components.Heading.sizes,
          xxs: {
            fontSize: 'md',
            lineHeight: '1.3',
          },
          xmd: {
            fontSize: 'lg',
            lineHeight: '1.3',
          },
        },
      },

      Skeleton: {
        defaultProps: {
          startColor: 'gray.dark',
          endColor: 'gray.dimmed',
        },
      },

      Button: {
        baseStyle: {
          borderRadius: '21px',
          fontWeight: fontWeights.bold,
          fontFamily: fonts.body,
        },

        variants: {
          outline: {
            color: 'black',
            borderColor: 'black',
            backgroundColor: 'transparent',
            _disabled: {
              _hover: {
                color: 'black',
              },
            },
            _hover: {
              bg: 'black',
              color: 'white',
            },
            _active: {
              bg: 'black',
              color: 'white',
            },
          },
        },
      },
    },
  },

  theme,
);
